export default "__VITE_ASSET__k1gX_BBn__"